import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { CallAgentService } from 'src/app/services/call-agent/call-agent.service';

@Component({
  selector: 'app-edit-order-modal',
  templateUrl: './edit-order-modal.page.html',
  styleUrls: ['./edit-order-modal.page.scss'],
})
export class EditOrderModalPage implements OnInit {
  @Input() docID: string;
  @Input() customerName: string;
  @Input() customerCellphone: string;
  @Input() destination: string;
  @Input() description: string;
  @Input() extraStops: string;
  @Input() store: string;
  @Input() paymentMethod: string;
  @Input() orderCost: number;
  @Input() deliveryFee: number;

  loading;

  constructor(
    private modalCtrl: ModalController,
    private callAgentService: CallAgentService,
    private loadingController: LoadingController
  ) {}

  ngOnInit() {
    console.log(this.docID);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  edit() {
    console.log(this.extraStops);
    console.log(this.description);
    console.log(this.docID);

    this.presentLoading();
    this.callAgentService
      .updateDescExtra(
        this.docID,
        this.description,
        this.extraStops,
        this.deliveryFee,
        this.orderCost
      )
      .then(() => {
        this.dismissLoading();
        this.closeModal();
        alert('Updated');
      })
      .catch((e) => {
        this.dismissLoading();
      });
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'loading...',
    });
    await this.loading.present();
  }

  async dismissLoading() {
    this.loading.dismiss();
  }
}
